{
  "Users": "Users",
  "UsersEmpAndActive": "Total users / SEB Employees",
  "Progressing User": "Progressing User",
  "Completing Users between": "Completing users between {{date}} and {{date2}}",
  "Progressing Users between": "Progressing users between {{date}} and {{date2}}",
  "User Population Overview": "User Population Overview",
  "Sum of all user accounts": "Sum of all user accounts",

  "progressing-user-definition": "A user that has made progress during last 30 days",
  "Completing User": "Completing User",
  "completing-user-definition": "A user that has completed minimum one course",

  "users": "Users",
  "total-users-definition": "Sum of all user accounts",
  "registered-users-definition": "Users that have logged in and are considered active",
  "pending-users-definition": "Users that are awaiting approval",
  "incomplete-users-definition": "Users that have not completed registration",
  "deactivated-users-definition": "Users that are deactivated",

  "completions-over-time-definition": "Number of completions per day over time",
  "total-effort-definition": "The total amount of hours aggregated from progress per course * total estimated time per course, ie. 50% progressed on a 10 hour course equals 5 hours spent.",

  "average-effort-per-user-definition": "Total effort divided by total number of users",
  "completions-definition": "Number of users who have completed a course",
  "participants-definition": "Number of users who have made any progress on a course",
  "completion-rate-definition": "Number of completing users divided by number of progressed users",
  "Completion Rate": "Completion Rate",
  "Average Effort Per User": "Average Effort Per User",
  "total-user-count-definition": "Total number of users",
  "Total Effort": "Total Effort",
  "Number of completions per day over time": "Number of completions per day over time",
  "Completions over time": "Completions over time",
  "Total User Count": "Total User Count",
  "Info": "Info",
  "Dashboard": "Dashboard",
  "Population": "Population",
  "To": "To",
  "From": "From",
  "And": "and",
  "Effort over time": "Effort over time",
  "Effort-over-time-definition": "Effort users has done over time (in hours)",
  "HR-data": "HR-data",
  "total-users": "{{count}} Users",
  "active-users": "{{count}} Active Users",
  "completing-users": "{{count}} Completing Users",
  "Popular Courses": "Popular Courses",
  "popular-courses-definition": "Courses sorted by completions",
  "hours": "{{count}} hours",

  "Content": "Content",
  "Title": "Title",
  "Completion rate": "Completion rate",
  "Participants": "Participants",
  "Completions": "Completions",
  "Clear filters": "Clear filters",
  "Completion": "Completion",
  "Download report": "Download report",
  "Download extended report": "Download extended report",
  "Select file format": "Select file format",
  "Analyze": "Analyze",
  "Progress": "Progress",
  "User statistics": "User statistics",
  "Analytics": "Analytics",
  "items-selected": "{{ count }} ITEM SELECTED",
  "items-selected_plural": "{{ count }} ITEMS SELECTED",
  "No title": "No title (id: {{ id }})",
  "Show Campus Online": "Show Campus Online",

  "Email": "Email",
  "First activity": "First activity",
  "Last activity": "Last activity",
  "Completed": "Completed",
  "Started": "Started",
  "Total effort (hours)": "Total effort (hours)",

  "status": "Status",
  "registered": "Registered",
  "in-progress": "In progress",
  "completed": "Completed",
  "expired": "Expired"
}
